import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'users';

const getBackofficeUserList = async () => {
  const method = 'GET';
  const url = `${USE_CASE_URL}`;

  const json = await request({ method, url });
  return json;
};

export default getBackofficeUserList;
